import { computed, effect, Injectable } from "@angular/core"
import { CorpForm } from "@corporate-tailwind/corp-form"
import { ContactDto } from "../model/contact.model"
import { ContactState } from "../state/contact.state"
import { TranslateService } from "@ngx-translate/core";

@Injectable({ providedIn: 'root' })
export class ContactService extends CorpForm<ContactDto> {
    customer$ = computed(() => this._state.contact());
    loading$ = computed(() => this._state.loading());
    isMessageSent$ = computed(() => this._state.isMessageSent());

    constructor(
        public _state: ContactState,
        private _translateService: TranslateService
    ) {
        super(ContactDto, ContactDto)

        // 🔄 synchroniser le form -> signal (normalement dans ngonInit)
        var valueChangeFormGroup = this.formGroup?.valueChanges.subscribe((value: any) => {
            this._state.patch(value)
        })

        // 🔄 synchroniser le signal -> form
        var effectSignal = effect(() => {
            const contact = this._state.contact()
            if (!contact) return
            
            contact.languageCode = this._translateService.getCurrentLang();
            this.safePatchValue(contact)
        })
    }

    init(): void {
        this._state.init()
    }

    save() {
        this._state.save(this.formGroup.getRawValue())
    }

}
